import * as React from 'react'
import { CurrencyCode } from 'codegen/types'
import { usePricesForUser } from '@repo/cf-user/hooks/use-prices'

import {
  promoMap,
  totalMap,
  productIdMap,
  formatPrice,
  savingMap,
  subtotalMap,
} from '../_components/config'
import type { Variant, MapKey } from '../_components/config'

export function useConfig(variant: Variant) {
  const { prices, currency, country: userCountry } = usePricesForUser()

  const mapKey: MapKey =
    (variant === 'freeTrial' || variant === 'monthly') &&
    currency &&
    currency.code === CurrencyCode.Usd
      ? `${variant}_usd`
      : variant

  const [promoCode, setPromoCode] = React.useState<string>(promoMap[mapKey])
  const [showPromo, setShowPromo] = React.useState<boolean>(
    variant !== 'freeTrial' && variant !== 'freeTrialYearly' && variant !== 'freeTrialAiStudio',
  )

  React.useEffect(() => {
    if (
      variant === 'freeTrial' ||
      variant === 'freeTrialYearly' ||
      variant === 'freeTrialAiStudio'
    ) {
      const params = new URLSearchParams(window.location.search)
      const promoCodeSearchParam = params.get('promo')
      setPromoCode(
        promoCodeSearchParam && variant === 'freeTrial' ? promoCodeSearchParam : promoMap[mapKey],
      )
      setShowPromo(true)

      if (promoCodeSearchParam) {
        //remove promo from query params
        params.delete('promo')
        const newParams = params.toString()

        window.history.replaceState(
          {},
          '',
          `${
            newParams.length === 0
              ? window.location.pathname
              : `${window.location.pathname}?${newParams}`
          }`,
        )
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  let saving = savingMap[mapKey]
  const pricePerMonth =
    variant === 'freeTrialAiStudio' ? prices.studioMonthly : prices.yearlyPromoMonthlySplit
  const pricePerMonthFull = prices.yearlyPromoMonthlyFull
  let subtotal = subtotalMap[mapKey]
  let total = totalMap[mapKey]
  const productId = productIdMap[mapKey]

  if (userCountry === 'NL') {
    if (variant === 'freeTrial' || variant === 'freeTrialYearly') {
      saving = prices.yearlyPromo
      subtotal = prices.yearlyPromo
    }
    if (variant === 'freeTrialAiStudio') {
      saving = prices.studioYearly
      subtotal = prices.studioYearly
    }
    if (variant === 'yearly') {
      total = prices.yearly
      saving = subtotal - prices.yearly
    }
    if (variant === 'yearlyPromo') {
      total = prices.yearlyPromo
      saving = subtotal - prices.yearlyPromo
    }
    if (variant === 'aiStudio') {
      total = prices.studioYearly
      saving = subtotal - prices.studioYearly
    }
    if (variant === 'monthly') {
      total = prices.monthly
      subtotal = prices.monthly
    }
  }

  return {
    mapKey,
    currency: currency,
    promoCode,
    showPromo,
    saving: formatPrice(saving),
    pricePerMonth: formatPrice(pricePerMonth),
    pricePerMonthFull: formatPrice(pricePerMonthFull),
    subtotal: formatPrice(subtotal),
    total: formatPrice(total),
    productId,
  }
}
